import initProfileInfo from './profile-info';
import './index.sass';
import './profile-about/index.sass';
import './profile-achievements/index.sass';
import './profile-statistic/index.sass';
import './profile-socials/index.sass';
import './admin_actions/index.sass';
import './profile-work/index.sass';
import axios from "axios";
import Cookies from 'js-cookie'

export default ($root) => {
  initProfileInfo();
  const $btn = $('.js-load-illustration');

  $btn.on('click', function (e) {
    e.preventDefault();
    const $el = $(this);
    initAjax($el);
  });

  const initAjax = ($el) => {
    if(!$el.data('url')) $el.hide();
    $root.find('.js-profile-list').append('<div class="list-loader"></div>');
    axios.get($el.data('url'), {
      headers: { 'Accept': 'application/json' }
    }).then((response) => {
      const resp = response;
      const $illustrations = $(resp.data.illustrations);
      const url = resp.data.url;
      if(url) {
        $el.data('url', url);
      } else {
        $el.remove();
      }
      $root.find('.js-profile-list').append($illustrations);
      $root.find('.list-loader').remove();
      if(resp.data.pagination) {
        $root.find('.profile__pagination').html(resp.data.pagination);
      }
    }).catch((error) => {
      console.log(error.response)
    });
  }


  let fileField;
  const csrfToken = {"X-CSRF-Token": $('meta[name=csrf-token]').attr('content')}
  const $profileInfo = $('.profile-info');
  const $profileInfoTop = $('.profile-info__top');
  const $btns = $('.profile-info__buttons');
  const $deleteBtn = $('.profile-info__button--delete');
  if ($root.find('#cover-upload-btn').length) {
    fileField = $('#cover-upload-field');
    fileField.fileupload({
      url: fileField.data('path'),
      type: 'POST',
      dataType: 'json',
      headers: csrfToken,
      formData: [],
      done: function(e, data) {
        let response;
        response = data.result;
        if (response.error) {
          return showError(response.error);
        } else {
          if ($('.profile-info__cover #cover-img').length > 0) {
            $('#cover-img').attr('src', response.image_url);
          } else {
            if($('.profile-info__button--delete').length){
              $deleteBtn.removeClass('profile-info__button--hidden');
              $btns.removeClass('profile-info__buttons--static');
              $profileInfo.removeClass('profile-info--padding');
              $profileInfoTop.addClass('profile-info__top--margin');
            }
            $('.profile-info__cover').prepend(`<img id="cover-img" src="${response.image_url}"/>`);
          }
        }
      },
      fail: function() {
        return showError(I18n.t('server_error'));
      }
    });
    $('#cover-remove-btn').click(function() {
      $.ajax({
        url: $(this).data('path'),
        method: 'POST',
        headers: csrfToken,
        data: {
          _method: 'delete'
        },
        success: function() {
          if($('.profile-info__button--delete').length){
            $deleteBtn.addClass('profile-info__button--hidden');
          }
          $('.profile-info__cover').find('#cover-img').remove();
          $profileInfo.addClass('profile-info--padding');
          $btns.addClass('profile-info__buttons--static');
          $profileInfoTop.removeClass('profile-info__top--margin');
        }
      });
      return false;
    });
  }
  if ($('.profile-modals').length === 0) {
    return;
  }
  const initWelcomeIllustratorPopup = () => {
    $.magnificPopup.open( {
      items: {
        src: '#welcome-illustrator-popup'
      },
      mainClass: 'mfp-welcome',
      type: 'inline',
      closeBtnInside: true,
      closeOnBgClick: true,
      callbacks: {
        close: function () {
          Cookies.set('welcome_illustrator_popup_shown', true);
        }
      }
    });
  }

  $('#welcome-illustrator-popup').length && initWelcomeIllustratorPopup()

  return $('.follow-button').on('ajax:success', function(e, data) {
    if (e.detail[0].follow) {
      $('.follow-button').removeClass('green').addClass('grey').text(I18n.t('unsubscribe')).attr('data-method', 'delete').data('method', 'delete').attr('href', e.detail[0].path);
    } else {
      $('.follow-button').addClass('green').removeClass('grey').text(I18n.t('subscribe')).attr('data-method', 'post').data('method', 'post').attr('href', e.detail[0].path);
    }
    $('#user_followers_open').find('.number').text(e.detail[0].followers);
    return $('#user_followers_open').data('count', e.detail[0].followers);
  });
}
